const CompactLogo = () => {
  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21.5" cy="21.5" r="21" fill="#F6F2F9" stroke="#380F52" />
      <path
        d="M30.0109 10.28C30.6082 10.28 31.0882 10.472 31.4509 10.856C31.8135 11.2187 31.9949 11.7093 31.9949 12.328V31.272C31.9949 31.8693 31.8242 32.3387 31.4829 32.68C31.1415 33.0213 30.6935 33.192 30.1389 33.192C29.5842 33.192 29.1469 33.0213 28.8269 32.68C28.5069 32.3387 28.3469 31.8693 28.3469 31.272V18.088L22.9069 28.392C22.6509 28.8613 22.3735 29.2133 22.0749 29.448C21.7762 29.6613 21.4242 29.768 21.0189 29.768C20.6135 29.768 20.2615 29.6613 19.9629 29.448C19.6642 29.2347 19.3869 28.8827 19.1309 28.392L13.6589 18.248V31.272C13.6589 31.848 13.4882 32.3173 13.1469 32.68C12.8269 33.0213 12.3895 33.192 11.8349 33.192C11.2802 33.192 10.8429 33.0213 10.5229 32.68C10.2029 32.3387 10.0429 31.8693 10.0429 31.272V12.328C10.0429 11.7093 10.2135 11.2187 10.5549 10.856C10.9175 10.472 11.3975 10.28 11.9949 10.28C12.8269 10.28 13.4775 10.7387 13.9469 11.656L21.0509 25.192L28.1229 11.656C28.5922 10.7387 29.2215 10.28 30.0109 10.28Z"
        fill="#380F52"
      />
    </svg>
  );
};

export default CompactLogo;
